// extracted by mini-css-extract-plugin
export default {"tableWrapper":"OrganizationDocumentsTemplate_tableWrapper__grH4M"};